export const MESSAGE_TYPE = {
  DANGER: "error",
  SUCCESS: "success",
  INFORMATION: "info",
  WARNING: "warning"
};

export const MESSAGE = {
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again later.",
  SORRY_SOMETHING_WENT_WRONG: "We're sorry, something went wrong please try again.",
  TRY_AGAIN_LATER: "Please try again later",
  AUTH_SET_UP: "Your two-factor authentication is set up with your mobile number: {phone}",
  TWO_FACTOR_TURNED_OFF: "You've turned off Two-Factor Authentication. You will receive no further message.",
  OTP_IS_INCORRECT: "This code is incorrect.",
  OTP_ATTEMPTS_EXHAUSTED: "The code you submitted was incorrect and all attempts have been used. Please try again later.",
  OTP_INCORRECT_LENGTH: "Your code must be 6 digits.",
  OTP_MISSING: "Please enter your six digit code.",
  ONE_PRIMARY_PHONE_ALLOWED: "Only one primary phone allowed.",
  PHONE_NUMBER_TAKEN: "Please try another phone number as this phone number is already registered with an account.",
  EMAIL_TAKEN: "This email address has already been registered.",
  PHONE_MISSING: "Please enter your phone number.",
  PHONE_INVALID: "Phone numbers must be 10 digits.",
  EMAIL_MISSING: "Please enter your email address.",
  EMAIL_INVALID: "Please provide your email address, formatted as you@domain.com.",
  PASSWORD_MISSING: "Please enter a password.",
  PASSWORD_USED: "You can't use your previous password. Please create a new password.",
  PASSWORD_TOO_SHORT: "Please use at least 8 characters.",
  PASSWORD_TOO_GUESSABLE: "You cannot use simple passwords such as your email, \"password\", \"password123\", etc.",
  PASSWORD_CHANGED: "You have successfully changed your password",
  PASSWORD_CURRENT_MISSING: "Please enter your password.",
  PASSWORD_CONFIRM_MISSING: "Please confirm your new password.",
  PASSWORD_CURRENT_INVALID: "We’re sorry, the password you entered is incorrect. Please try again.",
  PASSWORD_CONFIRM_INCORRECT: "Passwords do not match. ",
  PASSWORD_EXPIRED_FOR_INACTIVE_USERS: "We are unable to change your password at this time. Please try again later.",
  PASSWORD_OTP_IS_EXPIRED: "We are unable to verify your OTP code at this time. Please try again.",
  PASSWORDLESS_UNENROLL_SUCCESS: "You will now use a password to sign in to your account.",
  EMAIL_CHANGED: "You have successfully changed your email",
  DEVICE_SIGNED_OUT: "You have been successfully signed out of the selected device",
  CANT_SHOW_DEVICES: "We're sorry, we cannot show your signed in devices at this time.",
  SIGN_OUT_EVERYWHERE: "Are you sure you want to sign out of all devices?",
  SIGN_OUT_CURRENT_DEVICE: "Are you sure you want to sign out of the device you are currently using?",
  SIGN_OUT_DEVICE: "Are you sure you want to sign out of the selected device?",
  SECURITY_MESSAGE_NO_PHONE: "Add your phone number to help secure your account and turn on new features like Two-Factor Authentication.",
  SECURITY_MESSAGE_NO_2FA: "You can now increase account security by enabling Two-Factor Authentication.",
  PHONE_ADD_AND_VERIFY_SUCCESS: "You successfully saved and verified your new number. Enhance your account security by turning on Two-Factor Authentication.",
  PHONE_VERIFY_SUCCESS: "You successfully verified your number. Enhance your account security by turning on Two-Factor Authentication.",
  ERR_MANDATORY_PASSWORD: "Please add a password.",
  REGISTER_PASSWORD_MIN_LENGTH: "Please use at least 9 characters.",
  REGISTER_PASSWORD_EMAIL_COPY_INVALID: "Avoid using your name or email.",
  REGISTER_PASSWORD_INVALID_REQ: "Password must meet at least 3 of the requirements.",
  REGISTER_PASSWORD_COMMON_PASS: "You cannot use simple passwords such as your email, \"password\", \"password123\", etc.",
  PASSWORD_FAIL_REQUIREMENTS: "Password must meet at least 3 of the requirements.",
  SECURITY_MESSAGE_NO_PHONE_BEST: "Add your phone number for the best experience!",
  INVITE_TO_VERIFY_PHONE: "Verify your phone number to access advanced security features.",
  VERIFIED_PHONE_INVITE: "Thanks for verifying your phone number! Now try an advanced security feature below.",
  VERIFIED_PHONE_INVITE_2: "Enhance your account security by turning on Two-Factor Authentication.",
  SUCCESS_PASSWORDLESS_ENROLLMENT: "You can now sign in to your account without a password.",
  PASSWORDLESS_MESSAGE_STATUS: "You are currently signing in without a password. This is the recommended option.",
  WEBAUTHN_MESSAGE_ENROLLED_DEVICE: "You are currently signing in on this device using a one time passcode, your face or your fingerprint ID. This is the suggested option.",
  WEBAUTHN_EXHORT_MESSAGE: "You are currently signing in with a one time passcode on this device. Sign in faster by enabling Face or Fingerprint ID.",
  SUCCESSFUL_ENROLLMENT_WEBAUTHN_ALERT: "You can now sign in to your account on this device without a password using a one time passcode, your face or your fingerprint identification.",
  WEBAUTHN_FAILURE_MESSAGE: "There was a problem enabling Face or Fingerprint ID at this time. Please try again later.",
  SET_PASSWORD_SIGNIN_WITH_PASSWORD_INSTEAD_SUCCESS: "Your password was successfully saved. Protect your account by turning on Two-Factor Authentication.",
  SMS_LANDLINE: "The phone number on your account is a landline and cannot recieve text messages. Please choose another option to receive a one time passcode."
};

const ERROR_CODE_TO_MESSAGE_MAP = {
  // IAM-related errors
  "PASS_ERR_015": MESSAGE.OTP_IS_INCORRECT,
  "AUTH_ERR_122": MESSAGE.OTP_IS_INCORRECT,
  "AUTH_ERR_116": MESSAGE.PASSWORD_USED,
  "AUTH_ERR_104": MESSAGE.PASSWORD_USED,
  "AUTH_ERR_125": MESSAGE.OTP_ATTEMPTS_EXHAUSTED,
  "AUTH_ERR_129": MESSAGE.OTP_IS_INCORRECT,
  "AUTH_ERR_130": MESSAGE.PASSWORD_OTP_IS_EXPIRED,
  // SVOC-related errors
  "UREG_ERR_134": MESSAGE.ONE_PRIMARY_PHONE_ALLOWED,
  "UREG_ERR_224": MESSAGE.PHONE_NUMBER_TAKEN,
  "UREG_ERR_149": MESSAGE.EMAIL_TAKEN,
  "UREG_ERR_106": MESSAGE.PASSWORD_CURRENT_INVALID,
  "EMAIL_ALREADY_EXIST_001": MESSAGE.EMAIL_TAKEN,
  "AUTH_ERR_102": MESSAGE.PASSWORD_CURRENT_INVALID,
  "AUTH_ERR_116A": MESSAGE.PASSWORD_USED,
  // Cust-Auth related errors
  "UREG_ERR_168": MESSAGE.PASSWORD_FAIL_REQUIREMENTS,
  "UREG_ERR_146": MESSAGE.PHONE_NUMBER_TAKEN,
  "UREG_ERR_103": MESSAGE.PASSWORD_CURRENT_INVALID,
  "UREG_ERR_228": MESSAGE.PHONE_NUMBER_TAKEN,
  // Entering wrong OTP code
  "VRFYPH_ERR_009": MESSAGE.OTP_IS_INCORRECT,
  "IAM_ERR_005": MESSAGE.OTP_IS_INCORRECT,
  "IAM_ERR_014": MESSAGE.PASSWORD_USED,
  "IAM_ERR_037": MESSAGE.OTP_IS_INCORRECT,
};

export const getTwoFactorAuthMessage = (phone) => {
  const trimmedPhoneNumber = phone.replace(/[^0-9]/g, "");
  const formattedPhone = `${trimmedPhoneNumber.substring(0, 3)}-${trimmedPhoneNumber.substring(3,6)}-${trimmedPhoneNumber.substring(6)}`;
  return MESSAGE.AUTH_SET_UP.replace("{phone}", formattedPhone);
}

export const getErrorMessage = (errorCode) => {
  return ERROR_CODE_TO_MESSAGE_MAP[errorCode] || MESSAGE.SOMETHING_WENT_WRONG;
}
